import {
  Home,
  Clock,
  Users,
  FolderKanban,
  Building2,
  BarChart3,
  TrendingUp,
  CheckCircle2,
  GitBranch,
  Settings,
  CreditCard,
  Plug,
  Bell,
  Shield,
  UserCog,
  Monitor,
  FileText,
  Database,
  Sliders,
  Calendar,
  Briefcase,
  PoundSterling,
  Archive,
  Download,
  Upload,
  ClipboardCheck,
  AlertTriangle,
} from "lucide-react";
import type { MenuItem } from "../types";

/**
 * Menu Items Configuration
 * Define your menu structure here
 */
export const menuItems: MenuItem[] = [
  { id: "homepage", label: "Homepage", icon: Home, page: "/" },
  { id: "timesheet", label: "Timesheet", icon: Clock, page: "/timesheet" },
  { id: "approvals", label: "Approvals", icon: CheckCircle2, page: "/approvals" },
  { 
    id: "reports", 
    label: "Reports", 
    icon: BarChart3, 
    page: "/reports/timesheet",
    children: [
      { id: "reports-timesheet", label: "Timesheet Reports", icon: FileText, page: "/reports/timesheet" },
      { id: "reports-missing-timesheets", label: "Missing Timesheets", icon: AlertTriangle, page: "/reports/missing-timesheets" },
      { id: "reports-utilisation", label: "Utilisation", icon: TrendingUp, page: "/reports/utilisation" },
      { id: "reports-billable", label: "Billable Hours", icon: PoundSterling, page: "/reports/billable" },
    ]
  },
  { id: "analytics", label: "Analytics", icon: TrendingUp, page: "/analytics" },
  { 
    id: "team", 
    label: "Team", 
    icon: Users, 
    page: "/team/members",
    children: [
      { id: "team-members", label: "Members", icon: Users, page: "/team/members" },
      { id: "team-schedule", label: "Schedule", icon: Calendar, page: "/team/schedule" },
      { id: "team-capacity", label: "Capacity", icon: TrendingUp, page: "/team/capacity" },
    ]
  },
  { 
    id: "projects", 
    label: "Projects", 
    icon: FolderKanban, 
    page: "/projects/active",
    children: [
      { id: "projects-active", label: "Active", icon: FolderKanban, page: "/projects/active" },
      { id: "projects-archive", label: "Archive", icon: Archive, page: "/projects/archive" },
      { id: "projects-budget", label: "Budget", icon: PoundSterling, page: "/projects/budget" },
    ]
  },
  {
    id: "data",
    label: "Import/Export",
    icon: Database,
    page: "/data/import",
    children: [
      { id: "data-import", label: "Import", icon: Upload, page: "/data/import" },
      { id: "data-export", label: "Export", icon: Download, page: "/data/export" },
    ]
  },
];

/**
 * Settings Menu Items Configuration
 * Nested settings pages
 */
export const settingsMenuItems: MenuItem[] = [
  { id: "settings-general", label: "General", icon: Settings, page: "/settings/general" },
  { id: "settings-roles-permissions", label: "Roles & Permissions", icon: UserCog, page: "/settings/roles-permissions" },
  { id: "settings-approvals", label: "Approvals", icon: ClipboardCheck, page: "/settings/approvals" },
  { id: "settings-screens", label: "Screen Data Modes", icon: Monitor, page: "/settings/screens" },
  { id: "settings-roles", label: "Roles & Rates", icon: CreditCard, page: "/settings/roles" },
  { id: "settings-notifications", label: "Notifications", icon: Bell, page: "/settings/notifications" },
  { id: "settings-security", label: "Security", icon: Shield, page: "/settings/security" },
  { id: "integrations", label: "Integrations", icon: Plug, page: "/integrations" },
];

/**
 * Database Options Configuration
 * Not used in this application
 */
export const databases = [];

/**
 * Menu Configuration
 */
export const menuConfig = {
  /** Total number of pages (7 main + 9 children + 8 settings = 24) */
  totalPages: 24,
  /** Minimum pages required to enable favorites feature */
  favoritesThreshold: 10,
  /** Show database switcher in footer */
  showDatabaseSwitcher: false,
  /** Show settings button in footer */
  showSettings: true,
};
